import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  OutilsContainer,
  Header,
  HeaderTop,
  HeaderContent,
  TipsBadge,
  Description,
  HeaderIcon,
  ProposeButton,
  Title,
  ToolButton,
  ToolIcon,
  ToolText
} from './styles';

// Import icons
import outilsIcon from '../../assets/outils.png';
import comparateurIcon from '../../assets/comparer.png';
import lettresIcon from '../../assets/lettre.png';

const Outils = () => {
  const navigate = useNavigate();
  const [pressedButton, setPressedButton] = useState(null);

  const handlePressStart = (buttonId) => {
    setPressedButton(buttonId);
  };

  const handlePressEnd = (path) => {
    const currentButton = pressedButton;
    setPressedButton(null);
    if (currentButton) {
      setTimeout(() => {
        navigate(path);
      }, 150);
    }
  };

  const handlePressCancel = () => {
    setPressedButton(null);
  };

  return (
    <OutilsContainer>
      <Header>
        <HeaderTop>
          <HeaderContent>
            <TipsBadge>Tips</TipsBadge>
            <Description>
              Compare tes formations préférées pour avoir une vision + claire !
            </Description>
          </HeaderContent>
          <HeaderIcon src={outilsIcon} alt="Outils Icon" />
        </HeaderTop>
        <ProposeButton 
          onClick={() => { /* Keep onClick for accessibility, but main logic is in touch/mouse events */ }}
          onMouseDown={() => handlePressStart('propose')}
          onMouseUp={() => handlePressEnd('/settings/aide-meo')}
          onMouseLeave={handlePressCancel}
          onTouchStart={() => handlePressStart('propose')}
          onTouchEnd={() => handlePressEnd('/settings/aide-meo')}
          active={pressedButton === 'propose'}
        >
          Proposer un nouvel outil
        </ProposeButton>
      </Header>

      <Title>Mes outils</Title>

      <ToolButton 
        onClick={() => { /* Keep onClick */ }}
        onMouseDown={() => handlePressStart('comparateur')}
        onMouseUp={() => handlePressEnd('/comparateur')}
        onMouseLeave={handlePressCancel}
        onTouchStart={() => handlePressStart('comparateur')}
        onTouchEnd={() => handlePressEnd('/comparateur')}
        active={pressedButton === 'comparateur'}
      >
        <ToolIcon src={comparateurIcon} alt="Comparateur" />
        <ToolText>Comparateur</ToolText>
      </ToolButton>

      <ToolButton 
        onClick={() => { /* Keep onClick */ }}
        onMouseDown={() => handlePressStart('lettres')}
        onMouseUp={() => handlePressEnd('/lettres')}
        onMouseLeave={handlePressCancel}
        onTouchStart={() => handlePressStart('lettres')}
        onTouchEnd={() => handlePressEnd('/lettres')}
        active={pressedButton === 'lettres'}
      >
        <ToolIcon src={lettresIcon} alt="Lettres" />
        <ToolText>Lettres</ToolText>
      </ToolButton>
    </OutilsContainer>
  );
};

export default Outils; 